import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { messageClear } from "../store/reducers/authReducer"; /*obtneerr la url de envio*/
import toast from "react-hot-toast";
import { FadeLoader } from "react-spinners";

const CambiosyDevoluciones = () => {
  const navigate = useNavigate();
  const { loader, errorMessage, successMessage } = useSelector(state => state.auth);

  const dispatch = useDispatch();

  /*cambiar el dispath*/

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }

  }, [successMessage, errorMessage,  navigate, dispatch]);

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <Header />
      <div className="bg-slate-200 mt-4">
        <div className="w-full justify-center items-center p-10">
          <div className="max-w-6xl mx-auto bg-white rounded-md">
            <div className="px-8 py-8">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Política de Cambios</h2>

              <ul className="space-y-4 list-disc pl-5 text-gray-700">
                <li className="pb-2 border-b border-gray-100">
                  En caso de que el cliente desea realizar un cambio del modelo que ha comprado, este tiene un plazo de 7 días (Lima) o 10 días (Provincia) desde que recibió el modelo. Para poder
                  realizar un cambio el artículo debe estar sin usar y en las mismas condiciones en que lo recibió. También debe estar en el embalaje original.
                </li>

                <li className="pb-2 border-b border-gray-100">
                  En caso de querer realizar un cambio este solo se podrá realizar por el mismo modelo o por uno que su costo sea mayor. Si no encuentra un modelo de su agrado se le brindará una nota
                  de crédito del monto comprado (válida por 30 días), ya que no se hacen devoluciones de dinero.
                </li>

                <li className="pb-2 border-b border-gray-100">
                  Los modelos en <span className="font-semibold text-orange-500">«Oferta»</span> no están sujetos a cambios.
                </li>

                <li className="pb-2 border-b border-gray-100">
                  Para proceder con el cambio debe comunicarse al WhatsApp <span className="font-semibold text-blue-600">960 946 933</span> y enviar un video del modelo para verificar su condición.
                </li>

                <li className="pb-2 border-b border-gray-100">Todos los modelos deben ser enviados sellados y embalados correctamente para su protección durante el envío.</li>

                <li className="pb-2 border-b border-gray-100">
                  Los envíos de cambio se realizan a través de las agencias <span className="font-semibold">Shalon</span> más cercanas a su domicilio.
                </li>

                <li className="pb-2 border-b border-gray-100">
                  Todos los cambios se coordinan mediante el correo <span className="font-semibold text-blue-600">atencioncliente@tekos.pe</span>.
                </li>

                <li className="pb-2 border-b border-gray-100">
                  Si el modelo llegó con defectos de fábrica, debe enviar evidencias al correo electrónico <span className="font-semibold text-blue-600">atencioncliente@tekos.pe</span>, WhatsApp{" "}
                  <span className="font-semibold text-blue-600"></span> para su revisión y la respuesta se dará en un plazo máximo de 3 días hábiles.
                </li>

                <li>Se recomienda revisar cuidadosamente el visualizador de tallas antes de realizar su compra.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CambiosyDevoluciones;
